/**
 * REMOVABLE DEMO: cross-tree reader for the BYO-DB demo's AdminDemo
 * selections. Lives in `core/` so the app tree (e.g. the AwsInfrastructureMock
 * card in Clark AI) can react to provider choices made in the dashboard tree
 * without crossing the app/dashboard boundary. Delete with the demo.
 *
 * The dashboard side (AdminDemoProvider, AdminDemo/storage.ts) owns writes
 * and the broader config shape; this reader only exposes the slices the app
 * tree needs and is resilient to malformed storage entries.
 */
export const ADMIN_DEMO_STORAGE_KEY = "sb_admin_demo";

export type AdminDemoProviderRef = {
  providerId: string;
  providerName: string;
};

export type AdminDemoSelections = {
  database?: AdminDemoProviderRef;
  fileStorage?: AdminDemoProviderRef;
};

function isProviderRef(value: unknown): value is AdminDemoProviderRef {
  if (value === null || typeof value !== "object") return false;
  const ref = value as { providerId?: unknown; providerName?: unknown };
  return (
    typeof ref.providerId === "string" && typeof ref.providerName === "string"
  );
}

export function loadAdminDemoSelections(): AdminDemoSelections {
  try {
    const raw = window.localStorage.getItem(ADMIN_DEMO_STORAGE_KEY);
    if (raw === null) return {};
    const parsed = JSON.parse(raw) as Record<string, unknown>;
    const selections: AdminDemoSelections = {};
    if (isProviderRef(parsed["database"])) {
      selections.database = parsed["database"];
    }
    if (isProviderRef(parsed["fileStorage"])) {
      selections.fileStorage = parsed["fileStorage"];
    }
    return selections;
  } catch {
    return {};
  }
}
